
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 0L9.336 5.569l-5.82-2.054 2.056 5.82L0 12l5.572 2.661-2.057 5.824 5.82-2.056L12 24l2.664-5.571 5.82 2.056-2.052-5.824L24 12l-5.568-2.665 2.053-5.82-5.82 2.054z"}})])
          )
        }
      }
    